/**
 * trackEvent — Lightweight Frontend-Event-Tracking.
 *
 * Fire-and-forget: wirft nie, blockiert nie. Fehler werden nur geloggt,
 * damit kaputtes Tracking nie die UI beeinträchtigt.
 *
 * Verwendung:
 *   import { trackEvent } from "@/lib/trackEvent";
 *   trackEvent("pricing_page_viewed", { referrer: document.referrer });
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackEvent(event, properties = {}) {
  try {
    axios
      .post(`${API}/events`, { event, properties })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.debug("[track]", event, properties, err?.response?.status);
        }
      });
  } catch {
    // Nie werfen — Tracking darf UX nie brechen
  }
}
